import React, { useState, useRef, useEffect } from 'react';
import Add from '../icons/Add';

const ListViewColumnHeader = ({
  columns,
  visibleColumns,
  sortConfig,
  onSort,
  onToggleColumn,
}) => {
  const [showColumnMenu, setShowColumnMenu] = useState(false);
  const menuRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    if (!showColumnMenu) return;
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowColumnMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [showColumnMenu]);

  const handleSort = (e, key) => {
    e.stopPropagation();
    const col = columns.find((c) => c.key === key);
    if (!col?.sortable) return;
    onSort(key);
  };

  // Separate the title column from the rest
  const titleCol = columns.find((c) => c.alwaysVisible);
  const restCols = columns.filter((c) => !c.alwaysVisible);

  const titleIsActive = sortConfig.field === titleCol?.key;
  const titleArrow = titleIsActive
    ? sortConfig.direction === 'asc' ? '▲' : '▼'
    : null;

  return (
    <div className="list-view-column-header">
      {/* Frozen left: spacers + title */}
      <div className="col-frozen">
        <div className="col-drag-spacer" />
        <div className="col-check-spacer" />
        {titleCol && (
          <div
            className={`col-header-cell${titleCol.sortable ? ' sortable' : ''}${titleIsActive ? ' active-sort' : ''}`}
            style={{ width: 280, minWidth: 200, flexShrink: 0 }}
            onClick={(e) => handleSort(e, titleCol.key)}
          >
            <span className="col-header-label">{titleCol.label}</span>
            {titleArrow && <span className="col-sort-indicator">{titleArrow}</span>}
          </div>
        )}
      </div>

      {/* Scrollable columns */}
      {restCols.map((col) => {
        if (!visibleColumns.has(col.key)) return null;

        const isActive = sortConfig.field === col.key;
        const arrow = isActive
          ? sortConfig.direction === 'asc'
            ? '▲'
            : '▼'
          : null;

        return (
          <div
            key={col.key}
            className={`col-header-cell${col.sortable ? ' sortable' : ''}${isActive ? ' active-sort' : ''}`}
            style={{ width: col.width, flexShrink: 0 }}
            onClick={(e) => handleSort(e, col.key)}
          >
            <span className="col-header-label">{col.label}</span>
            {arrow && <span className="col-sort-indicator">{arrow}</span>}
          </div>
        );
      })}

      {/* Add column button (matches card row action menu width) */}
      <div className="col-add-wrapper" ref={menuRef}>
        <span
          className="col-add-btn"
          onClick={(e) => {
            e.stopPropagation();
            setShowColumnMenu(!showColumnMenu);
          }}
          data-tooltip-content="Show/hide columns"
          data-tooltip-id="zoobbe-tooltip"
        >
          <Add size={16} color="var(--muted-text-color)" />
        </span>

        {showColumnMenu && (
          <div className="col-visibility-dropdown">
            <div className="col-visibility-title">Columns</div>
            {columns
              .filter((c) => !c.alwaysVisible)
              .map((col) => (
                <label key={col.key} className="col-visibility-item">
                  <input
                    type="checkbox"
                    checked={visibleColumns.has(col.key)}
                    onChange={() => onToggleColumn(col.key)}
                  />
                  <span>{col.label}</span>
                </label>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ListViewColumnHeader;
